export var SET_REGION_SEO_CONTENT = 'SET_REGION_SEO_CONTENT';